import { ProfileSettingsProjectionStore } from './store'

export * from './store'

export const profileSettingsStore =
  ProfileSettingsProjectionStore.new()
